import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../shared/api-client/ApiClientProvider';
import { useProgram } from '../../loyalty/ProgramContext';

// ============================================================================
// Query Keys
// ============================================================================

export const participantUrlKeys = {
  all: ['participantUrl'] as const,
  byProgram: (programId: string) => [...participantUrlKeys.all, programId] as const,
};

// ============================================================================
// Hooks
// ============================================================================

/**
 * Fetches the participant URL (webview embed URL) for the current program.
 */
export function useParticipantUrl() {
  const { managerApi } = useApi();
  const { program } = useProgram();

  return useQuery({
    queryKey: participantUrlKeys.byProgram(program.id),
    queryFn: async () => {
      const embed = await managerApi.getEmbed(program.id);
      return embed.webview;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - this rarely changes
  });
}
